export default __webpack_public_path__ + "static/media/shb_logo.152a89fb.png";